import { UseRangeSliderReturn } from "@/hooks/useRangeSlider.js";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import { useMemo } from "react";
import tailwindConfig from "../../tailwind.config.js";

interface Props {
  rangeSlider: UseRangeSliderReturn;
  unit: string;
  step?: number;
}

const handleStyle = {
  backgroundColor: tailwindConfig.theme.colors.yellow[500],
  width: 20,
  height: 20,
  borderRadius: 9999,
  marginTop: -8,
  border: "2px solid #ffff",
};

const trackStyle = {
  backgroundColor: `${tailwindConfig.theme.colors.yellow[500]}`,
};

const RangeSlider = ({ rangeSlider, step, unit }: Props): JSX.Element => {
  const isMin = useMemo(
    () => rangeSlider.minQueryValue === undefined,
    [rangeSlider],
  );

  const isMax = useMemo(
    () => rangeSlider.maxQueryValue === undefined,
    [rangeSlider],
  );

  return (
    <div className="space-y-20 pt-8">
      <div className="flex items-center space-x-4">
        <input
          className={["w-80 text-xs", isMin && "text-disable"].join(" ")}
          value={rangeSlider.minInputValue}
          onChange={rangeSlider.inputChangeHandlers.min}
          type="number"
        />
        <span>-</span>
        <input
          className={["w-80 text-xs", isMax && "text-disable"].join(" ")}
          value={rangeSlider.maxInputValue}
          onChange={rangeSlider.inputChangeHandlers.max}
          type="number"
        />
        <span className="text-tiny">{unit}</span>
      </div>

      <div className="px-4">
        <Slider.Range
          min={rangeSlider.min}
          max={rangeSlider.max}
          step={step}
          value={[rangeSlider.minValue, rangeSlider.maxValue]}
          onChange={rangeSlider.sliderChangeHandler}
          onAfterChange={rangeSlider.sliderAfterChangeHandler}
          handleStyle={[handleStyle, handleStyle]}
          trackStyle={[trackStyle, trackStyle]}
        />
      </div>
    </div>
  );
};
export default RangeSlider;
